import {
    ALL_BRANDS_REQUEST,
    ALL_BRANDS_SUCCESS,
    ALL_BRANDS_FAIL,
    CREATE_BRAND_REQUEST,
    CREATE_BRAND_SUCCESS,
    CREATE_BRAND_FAIL,
    CREATE_BRAND_RESET,
    UPDATE_BRAND_REQUEST,
    UPDATE_BRAND_SUCCESS,
    UPDATE_BRAND_FAIL,
    UPDATE_BRAND_RESET,
    DELETE_BRAND_REQUEST,
    DELETE_BRAND_SUCCESS,
    DELETE_BRAND_FAIL,
    DELETE_BRAND_RESET,
    DELETE_BRANDS_REQUEST,
    DELETE_BRANDS_SUCCESS,
    DELETE_BRANDS_FAIL,
    DELETE_BRANDS_RESET,
    BRAND_PRODUCTS_REQUEST,
    BRAND_PRODUCTS_SUCCESS,
    BRAND_PRODUCTS_FAIL,
    BRAND_DETAILS_REQUEST,
    BRAND_DETAILS_SUCCESS,
    BRAND_DETAILS_FAIL,
    REMOVE_BRAND_DETAILS,
    CLEAR_ERRORS,
} from "../constants/brandConstants";

export const brandsReducer = (state = { brands: [] }, action) => {
    switch (action.type) {
        case ALL_BRANDS_REQUEST:
            return {
                loading: true,
                brands: [],
            };
        case ALL_BRANDS_SUCCESS:
            return {
                loading: false,
                brands: action.payload,
            };
        case ALL_BRANDS_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export const newBrandReducer = (state = { brand: {} }, action) => {
    switch (action.type) {
        case CREATE_BRAND_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case CREATE_BRAND_SUCCESS:
            return {
                loading: false,
                success: action.payload.success,
                brand: action.payload.brand,
            };
        case CREATE_BRAND_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CREATE_BRAND_RESET:
            return {
                ...state,
                success: false,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export const brandReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_BRAND_REQUEST:
        case DELETE_BRAND_REQUEST:
        case DELETE_BRANDS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case UPDATE_BRAND_SUCCESS:
            return {
                ...state,
                loading: false,
                isUpdated: action.payload,
            };
        case DELETE_BRAND_SUCCESS:
        case DELETE_BRANDS_SUCCESS:
            return {
                ...state,
                loading: false,
                isDeleted: action.payload,
            };
        case UPDATE_BRAND_FAIL:
        case DELETE_BRAND_FAIL:
        case DELETE_BRANDS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case UPDATE_BRAND_RESET:
            return {
                ...state,
                isUpdated: false,
            };
        case DELETE_BRAND_RESET:
        case DELETE_BRANDS_RESET:
            return {
                ...state,
                isDeleted: false,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export const brandDetailsReducer = (state = { brand: {} }, action) => {
    switch (action.type) {
        case BRAND_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case BRAND_DETAILS_SUCCESS:
            return {
                loading: false,
                brand: action.payload,
            };
        case BRAND_DETAILS_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        case REMOVE_BRAND_DETAILS:
            return {
                ...state,
                brand: {},
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};

export const brandProductsReducer = (state = { brand: {}, products: [] }, action) => {
    switch (action.type) {
        case BRAND_PRODUCTS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case BRAND_PRODUCTS_SUCCESS:
            return {
                loading: false,
                brand: action.payload.brand,
                products: action.payload.products,
            };
        case BRAND_PRODUCTS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
            };
        default:
            return state;
    }
};
